import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import firebase from '../../firebase';

import logo from '../../img/logo.svg';
import '../Quiz/Quiz.css';
import * as routes from "../../constants/routes";


class ForgotPassword extends Component {

    state = {
        email: '',
        isBtnActive: false,
        btnLoading: false,
        errorEmail: false,
        emailNotRegistered: false,
        errorMessage: '',
        emailSent: false
    };

    componentDidMount = () => {
        if(this.emailInput){
            this.emailInput.focus();
        }
    };

    validateEmail = (email) => {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    formIsValid = () => {
        return  this.state.email && !this.state.errorEmail;
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });

        if (e.target.name === 'email') {
            this.setState({errorEmail: !this.validateEmail(e.target.value)});
        }

        setTimeout(() => {
            if (this.formIsValid()) {
                this.setState({isBtnActive: true});
            } else {
                this.setState({isBtnActive: false});
            }
        }, 100);
    };

    handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.setState({
            btnLoading: true
        });

        firebase.auth().sendPasswordResetEmail(this.state.email).then(() => {
            // Email sent.
            this.setState({
                isBtnActive: false,
                btnLoading: false,
                emailSent: true,
                email: ''
            });
        }).catch((error) => {
            let message = error.message;
            if(error.code === 'auth/user-not-found'){
                message = "No user exists with that email address!";
            }
            this.setState({
                btnLoading: false,
                emailNotRegistered: true,
                errorMessage: message
            });
        });
    };

    render() {

        const {email, errorEmail, emailNotRegistered, errorMessage, isBtnActive, btnLoading, emailSent} = this.state;

        return (
            <div className="quiz">
                <div className="quiz__left-side">
                    <div className="quiz__area">

                        <div className="form">

                            <h1 className="form__title">Reset Password</h1>

                            <p className="form__desc">Please enter the email address you used when creating your account.</p>

                            <form method="post" className="form__wrapper forgot_password__form">

                                {!emailSent &&
                                    <div className="form__input-area">
                                        <label htmlFor="name" className="form__label">Email Address</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            className={'form__input' + (errorEmail ? ' input-error' : '')}
                                            placeholder="e.g. email@ema.com"
                                            ref={(email) => { this.emailInput = email; }}
                                            value={email}
                                            onChange={this.handleChange}
                                            onBlur={this.handleChange}
                                        />
                                    </div>
                                }

                                {emailNotRegistered &&
                                    <div className="clear">
                                        <p className="error__message">* {errorMessage}</p>
                                    </div>
                                }

                                {emailSent &&
                                    <div className="clear">
                                        <h3 className="color__purple">Please check your email inbox.</h3>
                                        <p className="color__purple">To reset your password, follow the instructions in the email we've just sent you from noreply@yoganosh.com</p>
                                    </div>
                                }

                                <button
                                    type="submit"
                                    className={`button button_send-form ` + (btnLoading ? 'loading__btn' : '')}
                                    onClick={this.handleSubmit}
                                    disabled={!isBtnActive}
                                >Send Reset Email</button>

                            </form>

                            <p className="form__additional">
                                Back to <Link to={routes.SIGN_IN}>Sign in</Link>
                            </p>

                        </div>

                    </div>
                </div>

                <div className="quiz__right-side">
                    <img src={logo} alt="" className="quiz__right-side-logo"/>

                    <div className="phone-container">
                        <div className="phone">
                            <div className="screen">
                                <div className="screen__number-container">
                                    <p className="screen__number">0</p>
                                    <p className="screen__number-text">complete</p>
                                </div>
                            </div>
                        </div>
                        <div className="phone-container__marker phone-container__marker_vitta">Vata</div>
                        <div className="phone-container__marker phone-container__marker_pitta">Pitta</div>
                        <div className="phone-container__marker phone-container__marker_kapha">Kapha</div>
                    </div>

                </div>
            </div>
        );
    }
}

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/components/Account/ForgotPassword.js